import { CardAffinity, CardType } from '../game/CardTypes';

export type UserSummaryStats = {
  rating: number | null;

  totalGames: number;
  totalWins: number;
  totalBlameMillis: number;
};

export type UserGameStats = {
  gamesPlayed: number;
  gamesWon: number;

  blameMillis: number;
  soloMillis: number;

  score: number;
  scoreFromCards: number;
  scoreFromProphecies: number;
  scoreFromTributes: number;

  clashes: number;
  clashesWon: number;

  // luckiestWinInfo: {
  //   delta: number;
  //   rolls: number[][];
  // };
  // unluckiestLossInfo: {
  //   delta: number;
  //   rolls: number[][];
  // };

  cardCountByAffinity: Partial<Record<CardAffinity, number>>;
  cardCountByType: Partial<Record<CardType, number>>;

  firstPickCardNames: Record<string, number>;
};
export function emptyUserGameStats(): UserGameStats {
  return {
    gamesPlayed: 0,
    gamesWon: 0,

    blameMillis: 0,
    soloMillis: 0,

    score: 0,
    scoreFromCards: 0,
    scoreFromProphecies: 0,
    scoreFromTributes: 0,

    clashes: 0,
    clashesWon: 0,

    cardCountByAffinity: {
      [CardAffinity.Derion]: 0,
      [CardAffinity.Tyros]: 0,
      [CardAffinity.Zeona]: 0,
      [CardAffinity.Basic]: 0,
    },
    cardCountByType: {
      [CardType.Building]: 0,
      [CardType.Unit]: 0,
      [CardType.Event]: 0,
    },

    firstPickCardNames: {},
  };
}

export function mergeUserGameStats(
  stats1: UserGameStats,
  stats2: UserGameStats,
): UserGameStats {
  return {
    gamesPlayed: stats1.gamesPlayed + stats2.gamesPlayed,
    gamesWon: stats1.gamesWon + stats2.gamesWon,

    blameMillis: stats1.blameMillis + stats2.blameMillis,
    soloMillis: stats1.soloMillis + stats2.soloMillis,

    score: stats1.score + stats2.score,
    scoreFromCards: stats1.scoreFromCards + stats2.scoreFromCards,
    scoreFromProphecies:
      stats1.scoreFromProphecies + stats2.scoreFromProphecies,
    scoreFromTributes: stats1.scoreFromTributes + stats2.scoreFromTributes,

    clashes: stats1.clashes + stats2.clashes,
    clashesWon: stats1.clashesWon + stats2.clashesWon,

    cardCountByAffinity: mergeCardCountMap(
      stats1.cardCountByAffinity,
      stats2.cardCountByAffinity,
    ),
    cardCountByType: mergeCardCountMap(
      stats1.cardCountByType,
      stats2.cardCountByType,
    ),

    firstPickCardNames: mergeCardCountMap(
      stats1.firstPickCardNames,
      stats2.firstPickCardNames,
    ),
  };
}

function mergeCardCountMap(
  a: { [key: string]: number },
  b: { [key: string]: number },
): { [key: string]: number } {
  const ret = { ...a };
  for (const key in b) {
    ret[key] = (ret[key] || 0) + b[key];
  }
  return ret;
}
